import { render } from "./shutdownRecord.vue?vue&type=template&id=6d762323&scoped=true"
import script from "./shutdownRecord.vue?vue&type=script&lang=js"
export * from "./shutdownRecord.vue?vue&type=script&lang=js"

import "./shutdownRecord.vue?vue&type=style&index=0&id=6d762323&scoped=true&lang=css"
import "./shutdownRecord.vue?vue&type=style&index=1&id=6d762323&lang=css"
script.render = render
script.__scopeId = "data-v-6d762323"

export default script